<template>
  <slideshow
    @previous="goToPreviousStrip"
    @next="goToNextStrip"
  >
    <template slot="title">
      <span :class="{disabled: !stripFormData}">
        <template v-if="stripFormData && stripFormData.number">
          <span>Strip {{ stripFormData.number }}</span>
          <template v-if="dateLabel">
            <span> · {{ dateLabel }}</span>
          </template>
        </template>
      </span>
      <small>
        <router-link :to="{name: 'ListStrips'}">Back to strips</router-link>
      </small>
    </template>
    <template slot>
      <loader v-if="loading" />
      <div v-else-if="stripFormData">
        <strip-form
          v-bind="stripFormData"
          @submit="save"
          @remove="remove"
          :disabled="saving"
          :showBanner="!strip"
        />
      </div>
      <div v-else>
        <new-strip @upload="onUpload" />
      </div>
    </template>
  </slideshow>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '@/components/Loader.vue';
import Slideshow from '@/components/Slideshow.vue';
import dayjs from 'dayjs';
import { FULLDATEFORMAT } from '@/utilities/time';
import StripForm from './StripForm.vue';
import NewStrip from './NewStrip.vue';

export default {
  name: 'EditStrip',
  props: {
    stripNumber: [Number, String],
  },
  components: {
    Loader,
    Slideshow,
    StripForm,
    NewStrip,
  },
  data() {
    return {
      strip: null,
      newStrip: null,
      loading: false,
      saving: false,
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route() {
      this.newStrip = null;
      this.fetchData();
    },
  },
  computed: {
    ...mapGetters(['getStrip']),
    stripFormData() {
      return this.strip || this.newStrip;
    },
    dateLabel() {
      return dayjs.unix(this.stripFormData.publishDate.seconds).format(FULLDATEFORMAT);
    },
  },
  methods: {
    ...mapActions([
      'fetchStrip',
      'createStrip',
      'updateStrip',
      'removeStrip',
    ]),
    fetchData() {
      this.loading = true;
      const { stripNumber } = this;
      this.fetchStrip({ stripNumber }).finally(() => {
        this.strip = this.getStrip(this.stripNumber);
        this.loading = false;
      });
    },
    goToPreviousStrip() {
      const previousStrip = parseInt(this.stripNumber, 10) - 1;
      this.$router.push({ params: { stripNumber: previousStrip } });
    },
    goToNextStrip() {
      const nextStrip = parseInt(this.stripNumber, 10) + 1;
      this.$router.push({ params: { stripNumber: nextStrip } });
    },
    onUpload(strip) {
      this.newStrip = strip;
    },
    save(strip) {
      this.saving = true;
      const saveFn = this.newStrip ? this.createStrip : this.updateStrip;
      saveFn(strip).then(() => {
        this.saving = false;
        this.fetchData();
      }).catch(() => {
        this.saving = false;
      });
    },
    remove(stripNumber) {
      if (this.newStrip) {
        this.newStrip = null;
      } else {
        this.saving = true;
        this.removeStrip(stripNumber).then(() => {
          this.saving = false;
          this.fetchData();
        });
      }
    },
  },
};
</script>
